export interface Activity {
  id: string;
  title: string;
  subtitle?: string; // New optional subtitle field
  date: string;
  location: string;
  description: string;
  type: 'trek' | 'travel' | 'sports' | 'other';
  images: string[];
  highlights: string[];
}

export const activities: Activity[] = [
  {
    id: '1',
    title: 'Lake Garibaldi Trek',
    subtitle: 'From classroom coloring to real-life adventure — a journey across continents and memories.', // New subtitle
    date: '2024-09-22',
    location: 'Garibaldi Provincial Park, Squamish, BC, Canada',
    description: `The first time I saw Lake Garibaldi, I was coloring it in.

I was a school student in India, studying a world map with a turquoise pencil. The instruction was simple: "Label and shade Lake Garibaldi." It was just a shape, a name to memorize for an exam. I filled in the outline and forgot about it.

Years later, as a student at UBC, I found myself at the trailhead, about to walk into that same map.

The trail offered no mercy. The first two kilometers were a steep, lung-burning incline, our heart rates pounding well over 165. We pushed through, fueled by the goal of an 18-kilometer round trip. A cliffside lunch with Squamish sandwiches tasted like victory because we were earning it.

Then, the forest canopy broke.

And there it was—the turquoise from my pencil, but alive. The sun lit the shoreline into a brilliant, shimmering version of the color I’d once chosen. Further out, it deepened into a majestic Persian blue, all guarded by the silent white of the Sphinx and Sentinel glaciers.

The water was ice-cold, just as the guides warned. But we swam anyway. It was a shock, a baptism into a landscape I had only ever shaded with pencil lead. Floating there, I was no longer a student at UBC, or a school kid in India. I was just a person, suspended in a color I had once created on paper, now feeling its chill on my skin.

I had traveled from a classroom to the very center of the map. And the reality was infinitely more breathtaking than my childhood coloring could ever have been.`,
    type: 'trek',
    images: [
      '/images/garibaldi-1.jpg',
      '/images/garibaldi-2.jpg',
      '/images/garibaldi-3.jpg'
    ],
    highlights: [
      '18 km round trip (planned 6-hour completion)',
      'First 2 km steep climb; heart rate peaked at 165 bpm',
      "Lunch on a cliff with sandwiches from Bevee's Sandwich Shop (Squamish)",
      'Breathtaking turquoise shore and Persian blue main lake; views of Sphinx & Sentinel Glaciers',
      'Swam in the chilly lake and dried under the sun',
      "Post-hike reward: chimichangas at Sunny Chibas"
    ]
  }
  
  // Add more activities as needed
];

// Debug: confirm module loads and how many activities are present
console.log('activities module loaded — count:', activities.length);

// Provide a default export in case a component imports default by mistake
export default activities;